import { useNavigate } from "react-router-dom";
import { CloseIcon } from "../../assets/svg/CloseIcon";
import { LogoWithTextIcon } from "../../assets/svg/LogoWithTextIcon";
import styles from "./LoginPage.module.scss";
import { useAppDispatch } from "../../redux/store";
import { useFormik } from "formik";
import * as Yup from "yup";
import { loginThunk } from "../../redux/reducers/user/userThunks";
import { hideLoader, showLoader } from "../../redux/reducers/app/appReducer";
import { IUserLoginRequestData } from "../../redux/reducers/user/userTypes";

export const LoginPage = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const onSubmit = async (values: IUserLoginRequestData) => {
    try {
      dispatch(showLoader());
      await dispatch(loginThunk(values)).unwrap();
      navigate("/activeTab=environment");
    } catch (e: any) {
      console.error(e.message);
    } finally {
      dispatch(hideLoader());
    }
  };

  const formik = useFormik({
    initialValues: {
      username: "",
      password: "",
    },
    onSubmit,
    validationSchema: Yup.object({
      username: Yup.string().required("Email is a required field"),
      password: Yup.string()
        .min(8, "Must be more than 8 characters")
        .max(32, "Must be less than 50 characters")
        .required("Password is required"),
    }),
  });

  return (
    <div className={styles.wrapper}>
      <div className={styles.login}>
        <LogoWithTextIcon />
        <form className={styles.form} onSubmit={formik.handleSubmit}>
          <div className={styles.header}>
            <span>Login into studio</span>
            {/* <button type="button">
              <CloseIcon />
            </button> */}
          </div>
          <div className={styles.content}>
            <div className={styles.item}>
              <label htmlFor="username">Email</label>
              <input
                type="text"
                id="username"
                name="username"
                placeholder="Enter email"
                onChange={formik.handleChange}
              />
              {formik.touched.username && formik.errors.username ? (
                <div className={styles.error_message}>
                  {formik.errors.username}
                </div>
              ) : null}
            </div>
            <div className={styles.item}>
              <label htmlFor="password">Password</label>
              <input
                type="password"
                id="password"
                name="password"
                placeholder="Enter password"
                onChange={formik.handleChange}
              />
              {formik.touched.password && formik.errors.password ? (
                <div className={styles.error_message}>
                  {formik.errors.password}
                </div>
              ) : null}
            </div>
          </div>
          <div className={styles.footer}>
            <button type="submit">Login</button>
          </div>
        </form>
      </div>
    </div>
  );
};
